<template>
    <div class="fullscreen-box">
        <div class="fullscreen-box--outer">
            <div class="fullscreen-box--inner">
                <div class="fullscreen-box--container">
                    <div class="fullscreen-box--content">
                        <b-container class="register-center">
                            <error-logo></error-logo>
                            <error-404-content></error-404-content>
                        </b-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ErrorLogo from './ErrorLogo.vue'
    import Error404Content from './404/Error404Content.vue'
    import Error404Links from './404/Error404Links.vue'

    export default {
        components: { ErrorLogo, Error404Content, Error404Links },
        beforeCreate () {
            this.$store.commit('setError', {
                status: true,
                code: 404,
                redirect: false
            })
        },
        beforeMount () {
            this.$store.commit('loginFormView', 2)
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/_colors.scss';
    @import '../../assets/scss/_guest.scss';

    .fullscreen-box{
        background-image: url('../../assets/img/register_background.jpg');
    }

    .register-center{
        max-width: 620px;
        min-width: 320px;
    }

    @media(max-width:991px){
        .register-center{
            max-width: 100%;
            min-width: 320px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/errors/Error404.vue